import React from 'react';
import { CheckIcon, ShieldCheckIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
const included = ['All 6 volumes', 'All 5 bonuses', '30+ protocols and checklists', 'Case trackers', 'Quick Reference Cards', 'Planning tools', 'Review frameworks'];
export function Guarantee() {
  return <section className="w-full bg-white py-14 sm:py-20" data-id="element-175" data-mp="29eq5x1x069go">
      <div className="mx-auto w-full max-w-3xl px-4" data-id="element-176" data-mp="2ed9tt7v5pvbo">
        <div className="rounded-3xl border-2 border-mint/40 bg-mint/[0.08] p-6 text-center sm:p-10" data-id="element-177" data-mp="2eci1q70rqfq5">
          <span className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-mint text-white" data-id="element-178" data-mp="2ja9pqpyalhp2">
            <ShieldCheckIcon className="h-8 w-8" aria-hidden="true" data-id="element-179" data-mp="2o931odxxl0n4" />
          </span>
          <p className="mt-4 text-xs font-extrabold uppercase tracking-[0.18em] text-navy-500" data-id="element-180" data-mp="2sbzroppsvz13">
            🛡️ 7-day money-back guarantee
          </p>
          <h2 className="mt-2 font-display text-2xl font-black uppercase leading-tight text-navy-800 sm:text-3xl" data-id="element-181" data-mp="xy89v2xbi8uk">
            Try Aligner Control System™ risk-free
          </h2>

          <p className="mt-4 text-sm font-bold uppercase tracking-wide text-navy-600" data-id="element-182" data-mp="3nuq2hy6g701l">
            Get immediate access to
          </p>
          <ul className="mx-auto mt-3 flex max-w-md flex-col gap-2 text-left" data-id="element-183" data-mp="3iwolrjwhvcta">
            {included.map(item => <li key={item} className="flex items-center gap-2 rounded-xl bg-white px-3 py-2 text-sm font-semibold text-navy-700" data-id="element-184" data-mp="3dy3ifbly4d0m">
                <CheckIcon className="h-4 w-4 shrink-0 text-mint" aria-hidden="true" data-id="element-185" data-mp="agv3azilrr9l" />
                {item}
              </li>)}
          </ul>

          <p className="mt-5 text-sm leading-relaxed text-navy-600" data-id="element-186" data-mp="gulji0dtj7i">
            Explore the entire system for 7 days. If you decide that ALIGNER
            CONTROL SYSTEM™ isn’t the right fit for your professional workflow,
            you can request a refund according to the terms of the offer.
          </p>
        </div>

        <div className="mt-10 flex justify-center" data-id="element-187" data-mp="1d6bjhdpgcjnu">
          <CTAButton label="Try it for 7 days" data-id="element-188" data-mp="1h8zpzeqp1ehn" />
        </div>
      </div>
    </section>;
}